import Vue from 'vue'
import store from '..'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  namespaced: true,
  state () {
    return {
      chatRef: [],
      reference: null
    }
  },
  getters: {
    chatRef (state) {
      return state.chatRef
    },
    reference (state) {
      return state.reference
    }
  },
  mutations: {
    init (state, payload) {
      state.chatRef = payload
    },
    add (state, payload) {
      state.chatRef.push(payload)
    },
    update (state, payload) {
      const index = state.chatRef.findIndex(ref => ref.key === payload.key)
      if (index !== -1) {
        Vue.set(state.chatRef, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.chatRef.findIndex(ref => ref.key === payload.key)
      if (index !== -1) {
        state.chatRef.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      commit('init', [])
    },
    subscribe ({ commit }) {
      var boot = true
      var temp = []
      return new Promise((resolve, reject) => {
        commit('init', [])
        var user = this.getters['auth/user']
        const db = firebase.firestore()
        var dbRef = db.collection('chats_refs').doc(user.uid).collection('refs')
        var reference = dbRef.orderBy('updatedAt', 'desc').onSnapshot(snapshots => {
          if (snapshots.empty) {
            resolve()
          }
          snapshots.docChanges().forEach(change => {
            const payload = {
              key: change.doc.id,
              location: change.doc.data().location,
              status: change.doc.data().status,
              type: change.doc.data().type,
              enable: change.doc.data().enable,
              createdAt: change.doc.data().createdAt,
              updatedAt: change.doc.data().updatedAt
            }
            var data = JSON.parse(JSON.stringify(payload))
            if (boot && change.type === 'added') {
              temp.push(data)
            } else if (change.type === 'added') {
              commit('add', data)
            } else if (change.type === 'modified') {
              commit('update', data)
            } else if (change.type === 'removed') {
              commit('remove', data)
            }
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        })
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      return new Promise((resolve, reject) => {
        var reference = store.getters['chatRef/reference']
        if (reference) {
          reference()
          commit('init', [])
          resolve()
        } else {
          resolve()
        }
      })
    },
    follow ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const db = firebase.firestore()
        const batch = db.batch()
        var refChats = null
        var refChatsRefFrom = null
        var location = null
        var timestamp = parseInt(new Date().getTime() / 1000)
        if (payload.type === 'user') {
          refChats = db.collection('chats').doc()
          location = refChats.id
          batch.set(refChats, { 'chats_owner': payload.from, 'createdAt': new Date().getTime(), 'unread': 0, 'schools': payload.schools })
          refChatsRefFrom = db.collection('chats_refs').doc(payload.from).collection('refs').doc(payload.to.key)
        } else {
          location = payload.to.chats
          refChatsRefFrom = db.collection('chats_refs').doc(payload.from).collection('refs').doc(payload.to.key)
        }
        batch.set(refChatsRefFrom,
          {
            'location': location,
            'type': payload.type,
            'status': payload.type === 'user' ? 'pending' : 'accepting',
            'enable': true,
            'public': false,
            'createdAt': timestamp,
            'updatedAt': timestamp
          }
        )
        var refChatsRefTo = db.collection('chats_refs').doc(payload.to.key).collection('refs').doc(payload.from)
        batch.set(refChatsRefTo,
          {
            'location': location,
            'type': 'user',
            'status': payload.type === 'user' ? 'requesting' : 'accepting',
            'enable': true,
            'public': false,
            'createdAt': timestamp,
            'updatedAt': timestamp
          }
        )
        batch.commit().then(function () {
          const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
          pause(100).then(() => {
            // console.log('Document successfully written!')
            resolve()
          })
        })
      })
    },
    followShareGroup ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const db = firebase.firestore()
        const batch = db.batch()
        var refChatsRefFrom = null
        var location = null
        var timestamp = parseInt(new Date().getTime() / 1000)
        location = payload.from.location
        refChatsRefFrom = db.collection('chats_refs').doc(payload.from.key).collection('refs').doc(payload.to.key)
        batch.set(refChatsRefFrom,
          {
            'location': location,
            'type': 'user',
            'status': 'accepting',
            'enable': true,
            'public': false,
            'createdAt': timestamp,
            'updatedAt': timestamp
          }
        )
        var refChatsRefTo = db.collection('chats_refs').doc(payload.to.key).collection('refs').doc(payload.from.key)
        batch.set(refChatsRefTo,
          {
            'location': location,
            'type': payload.type,
            'status': 'accepting',
            'enable': true,
            'public': false,
            'createdAt': timestamp,
            'updatedAt': timestamp
          }
        )
        batch.commit().then(function () {
          const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
          pause(100).then(() => {
            // console.log('Document successfully written!')
            resolve()
          })
        })
      })
    },
    unfollow ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const db = firebase.firestore()
        const batch = db.batch()
        var refChatsRefFrom = null
        refChatsRefFrom = db.collection('chats_refs').doc(payload.from).collection('refs').doc(payload.to.key)
        batch.delete(refChatsRefFrom)
        var refChatsRefTo = db.collection('chats_refs').doc(payload.to.key).collection('refs').doc(payload.from)
        batch.delete(refChatsRefTo)
        if (payload.type === 'user') {
          var refChats = db.collection('chats').doc(payload.parameter.location)
          batch.delete(refChats)
        }
        batch.commit().then(function () {
          const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
          pause(100).then(() => {
            // console.log('Document successfully written!')
            resolve()
          })
        })
      })
    },
    accept ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const db = firebase.firestore()
        const batch = db.batch()
        var refChatsRefFrom = null
        var timestamp = new Date().getTime()
        refChatsRefFrom = db.collection('chats_refs').doc(payload.from).collection('refs').doc(payload.to.key)
        batch.update(refChatsRefFrom,
          {
            'status': 'accepting',
            'updatedAt': timestamp
          }
        )
        var refChatsRefTo = db.collection('chats_refs').doc(payload.to.key).collection('refs').doc(payload.from)
        batch.update(refChatsRefTo,
          {
            'status': 'accepting',
            'updatedAt': timestamp
          }
        )
        batch.commit().then(function () {
          const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
          pause(100).then(() => {
            // console.log('Document successfully written!')
            resolve()
          })
        })
      })
    }
  }
}
